/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["div#details[_ngcontent-%COMP%]{margin:1em}.dx-field[_ngcontent-%COMP%]{margin:0;min-height:unset}.dx-field-label[_ngcontent-%COMP%], .dx-field-value-static[_ngcontent-%COMP%]{padding-top:2px;padding-bottom:2px}"];
export { styles as styles };
